import React, { useEffect, useState } from 'react';
import "./Profile.css";
import { useApiData } from "../../components/ApiDataProvider/ApiDataProvider";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Profile = () => {
  const [userDetails, setUserDetails] = useState(null);
  const { updateApiData } = useApiData(["user"]);
  const [editForm, setEditForm] = useState({
    name: '',
    emailId: '',
    phone: '',
    address: ''
  });

  useEffect(() => {
    const storedUserDetails = JSON.parse(localStorage.getItem('userDetails'));
    if (storedUserDetails) {
      setUserDetails(storedUserDetails);
      setEditForm({
        name: storedUserDetails.name || '',
        emailId: storedUserDetails.emailId || '',
        phone: storedUserDetails.phone || '',
        address: storedUserDetails.address || ''
      });
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!userDetails || !userDetails._id) {
      console.error("User ID is not available");
      return;
    }

    try {
      const updatedData = await updateApiData(`user/${userDetails._id}`, "PUT", editForm);

      // Update only necessary values in localStorage
      const newStoredData = { ...userDetails, ...editForm };
      localStorage.setItem('userDetails', JSON.stringify(newStoredData));
      setUserDetails(newStoredData);
      toast.success('Profile updated successfully!');
    } catch (error) {
      console.error('Error updating profile:', error);
      toast.error('Error updating profile. Please try again.');
    }
  };

  if (!userDetails) {
    return <div>Loading...</div>;
  }

  return (
    <div className="profile-container">
      <form onSubmit={handleSubmit} className="profile-edit-form">
        <div className="profile-form-group">
          <label className="profile-label">Name:</label>
          <input
            type="text"
            name="name"
            value={editForm.name}
            onChange={handleInputChange}
            className="profile-input"
          />
        </div>

        <div className="profile-form-group">
          <label className="profile-label">Email:</label>
          <input
            type="email"
            name="emailId"
            value={editForm.emailId}
            onChange={handleInputChange}
            className="profile-input"
          />
        </div>

        <div className="profile-form-group">
          <label className="profile-label">Phone:</label>
          <input
            type="text"
            name="phone"
            value={editForm.phone}
            onChange={handleInputChange}
            className="profile-input"
          />
        </div>

        <div className="profile-form-group">
          <label className="profile-label">Address:</label>
          <input
            type="text"
            name="address"
            value={editForm.address}
            onChange={handleInputChange}
            className="profile-input"
          />
        </div>

        <div className="profile-form-group">
          <label className="profile-label">Role:</label>
          <input
            type="text"
            value={userDetails.role?.roleName || userDetails.role || 'N/A'}
            disabled
            className="profile-input view-only"
          />
        </div>

        <div className="profile-form-group">
          <label className="profile-label">Project:</label>
          <input
            type="text"
            value={userDetails.project?.projectName || userDetails.project || 'N/A'}
            disabled
            className="profile-input view-only"
          />
        </div>

        <button type="submit" className="profile-save-button">
          Save Changes
        </button>
      </form>

      <ToastContainer />
    </div>
  );
};

export default Profile;
